import localforage from 'localforage';
import type { EnergyTypes, StandardTypes } from '../types';

export const useStandardStorage = () => {
  // Stores
  const { energyType, areaId, period, standardType } = storeToRefs(standardStore());
  const { getAreas } = areaStore();

  // Composables
  const { availableArea, availableEnergyType } = coreAreaHelper();

  // Data
  const clientId = computed(() => globalStore().getSelectedClient);
  const siteId = computed(() => globalStore().getSelectedSite);

  const getKeysFromForage = async () => {
    const areaForage = await localforage.getItem<number>(`nrjx-${clientId.value}-${siteId.value[0]}-standard-area`);
    const energyTypeForage = await localforage.getItem<EnergyTypes>(`nrjx-${clientId.value}-${siteId.value[0]}-standard-energy-type`);
    const periodForage = await localforage.getItem<string>(`nrjx-${clientId.value}-${siteId.value[0]}-standard-period`);
    const periodForageParsed = JSON.parse(periodForage ?? '{}');
    const standardTypeForage = await localforage.getItem<StandardTypes>(`nrjx-${clientId.value}-${siteId.value[0]}-standard-standard-type`);

    // SET
    if (areaForage) areaId.value = areaForage;
    if (standardTypeForage) standardType.value = standardTypeForage;
    if (energyTypeForage) energyType.value = energyTypeForage;
    if (periodForageParsed?.start && periodForageParsed?.end) period.value = periodForageParsed;

    // CHECK
    areaId.value = availableArea(getAreas, areaId.value) ?? areaId.value;
    energyType.value = availableEnergyType(areaId.value, energyType.value) ?? energyType.value;
  };

  const setKeysInForage = async () => {
    if (areaId.value) {
      await localforage.setItem<number>(`nrjx-${clientId.value}-${siteId.value[0]}-standard-area`, areaId.value);
    }
    await localforage.setItem<string>(`nrjx-${clientId.value}-${siteId.value[0]}-standard-energy-type`, energyType.value);
    await localforage.setItem<string>(`nrjx-${clientId.value}-${siteId.value[0]}-standard-period`, JSON.stringify(period.value));
    await localforage.setItem<StandardTypes>(`nrjx-${clientId.value}-${siteId.value[0]}-standard-standard-type`, standardType.value);
  };

  return { getKeysFromForage, setKeysInForage };
};
